export default "<div class=\"left-side\">\n  <img [src]=\"src\" />\n</div>\n<div class=\"right-side\">\n  <img [src]=\"src\" />\n</div>\n"